const PRIMARY_COLOR = '#3f51b5';
const COLOR_WHITE = '#ffffff';
const COLOR_BLACK = '#000000';
const COLOL_BLUE = '#333996';

export { PRIMARY_COLOR, COLOR_WHITE, COLOR_BLACK, COLOL_BLUE };
